import { translate } from '../i18n';

// 학년 값('4학년', '대학교 2학년', '성인')은 서버에 그대로 저장되므로 바꾸지 않는다.
// 화면에 보이는 label 만 현재 언어로 번역한다.
const GRADE_VALUES = [
  ...Array.from({ length: 12 }, (_, i) => `${i + 1}학년`),
  ...Array.from({ length: 4 }, (_, i) => `대학교 ${i + 1}학년`),
  '성인',
];

/** 저장된 학년 값('4학년', '대학교 2학년', '성인') → 현재 언어 라벨. 모르는 값은 그대로 */
export function translateGradeLabel(value) {
  if (!value) return value;
  const school = /^(\d+)학년$/.exec(value);
  if (school) return translate('registration.grade.school', { n: school[1] });
  const university = /^대학교\s*(\d+)학년$/.exec(value);
  if (university) return translate('registration.grade.university', { n: university[1] });
  if (value === '성인') return translate('registration.grade.adult');
  return value;
}

function createOption(value) {
  return {
    value,
    // 렌더링 시점에 읽으므로 언어가 바뀌면 라벨도 바뀐다.
    get label() {
      return value ? translateGradeLabel(value) : translate('registration.grade.placeholder');
    },
  };
}

export const GRADE_OPTIONS = ['', ...GRADE_VALUES].map(createOption);
